/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ChangeStatus from './ChangeStatus/index'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/Keys/Content",
  value
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={value}
 marginTop={dtSpaceM}
/>
<ChangeStatus
  viewPath={`${viewPath}/ChangeStatus`}
/>
{children}
</React.Fragment>)
}